import { Typography } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"
import type React from "react"
import { InfoRow } from "../Charts/LegendStyles"
import { extraColors } from "../../utils/theme"
import { NWSS_EVENT_DETECTION_TOOLTIP_LABEL } from "./nwssDisplayFormat"

export interface NwssTooltipInfoRowProps {
  label: string
  value: React.ReactNode
  valueSx?: SxProps<Theme>
  rowSx?: SxProps<Theme>
}

export const NwssTooltipInfoRow: React.FC<NwssTooltipInfoRowProps> = ({
  label,
  value,
  valueSx,
  rowSx,
}) => (
  <InfoRow sx={rowSx}>
    <Typography variant="tiny" color={extraColors.medium}>
      {label}
    </Typography>
    <Typography variant="tiny" sx={valueSx}>
      {value}
    </Typography>
  </InfoRow>
)

export interface NwssTooltipDetectedRowProps {
  isDetected: boolean
}

export const NwssTooltipDetectedRow: React.FC<NwssTooltipDetectedRowProps> = ({
  isDetected,
}) => (
  <NwssTooltipInfoRow
    label="Detected"
    value={isDetected ? "Yes" : "No"}
    valueSx={{
      color: isDetected
        ? extraColors.status.redLight
        : extraColors.status.greenLight,
      fontWeight: 700,
    }}
  />
)

export const NwssTooltipEventMemberRow: React.FC = () => (
  <NwssTooltipInfoRow label={NWSS_EVENT_DETECTION_TOOLTIP_LABEL} value="Yes" />
)

export const nwssEventMemberItemSx = (isEventMember: boolean) =>
  isEventMember
    ? {
        borderLeft: `2px solid ${extraColors.status.navyLight}`,
        pl: 1,
      }
    : undefined
